import { render, staticRenderFns } from "./MainMember.vue?vue&type=template&id=54b60d25"
import script from "./MainMember.vue?vue&type=script&lang=js"
export * from "./MainMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports